import Link from 'next/link'
import classes from './Footer.module.css'

export default function Footer() {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.links}>
            <Link href="/terms" className={classes.link}>
              Terms of Service
            </Link>
            <Link href="/privacy" className={classes.link}>
              Privacy Policy
            </Link>
            <Link href="mailto:support@mentorsub.com" className={classes.link}>
              Support
            </Link>
          </div>
          
          <div className={classes.copyright}>
            © {currentYear} MentorSub. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}